import { css } from "@emotion/react";
import type { ClassAttributes, HTMLAttributes } from "react";
import { Text } from "src/components/Text/Text.tsx";
import type { ExactTheme } from "src/lib/emotion/theme.ts";

export const TabsDropdownTrigger = (
  props: HTMLAttributes<HTMLButtonElement> & ClassAttributes<HTMLButtonElement>,
) => {
  return (
    <button css={dropdownTriggerStyles} {...props}>
      <Text css={dropdownTriggerTitleStyles} variant="body2">
        <i className={"icon-15-arw_dw"} css={dropdownTriggerArrowStyles} />
      </Text>
    </button>
  );
};

const dropdownTriggerStyles = css`
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 15px 0;
  height: 35px;
  display: flex;
  align-items: center;
  position: relative;
  top: 1px;
  flex-shrink: 0;
`;

const dropdownTriggerTitleStyles = (theme: ExactTheme) => css`
  color: ${theme.colorsV2.grey[800]};
  display: block;
`;
const dropdownTriggerArrowStyles = css`
  display: block;
`;
